__webpack_require__.p = "/wp-content/themes/adoozy/react-app/build/";